<template>
  <div>
    <div>
      <div>
        <div class="second-bar-admin">
          <v-row>
            <v-col cols="12" class="pt-0 pb-0">
              <CountStatusUIv2
                :filterForm="filterForm"
                :totalContactModule="totalContactModule"
                :typeHeaderContactModule="typeHeaderStatusModule"
                :contactModuleList="countStatusModuleList"
                typeBlended="tutor"
                :priorityConfig="priorityConfig"
              ></CountStatusUIv2>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <div>
        <student-high-care-table
          :filterForm="filterForm"
          :filterFormChange="filterFormChange"
          :priorityConfig="priorityConfig"
        ></student-high-care-table>
    </div>
  </div>
</template>

<script>
import CountStatusUIv2 from '@/components/common/CountStatusUIv2/index.vue';
import { mapActions, mapState } from 'vuex';
import StudentHighCareTable from './StudentHighCareTable.vue';

export default {
  name: 'PeriodicallyCare',
  props: {
    filterForm: {
      type: Object,
      default: () => {
      },
    },
    filterFormChange: {
      type: Object,
      default: () => {},
    },
    priorityConfig: {
      type: Number,
      required: true,
    },
  },
  // mounted() {
  //   this.getListCallType({
  //     'filters[$eq__typeCustomerCare]': this.filterForm.typeCustomerCare,
  //     'filters[$eq__type_curriculum]': this.filterForm.type_curriculum,
  //   });
  // },
  computed: {
    ...mapState('blended', ['countStatusModuleList', 'totalContactModule', 'typeHeaderStatusModule']),
  },
  methods: {
    ...mapActions('student_care', ['getListProgram', 'getListCallType']),
  },
  components: {
    CountStatusUIv2,
    StudentHighCareTable,
  },
};
</script>

<style scoped>
.second-bar {
  margin-top: 15px;
  min-height: 39px;
  min-width: 900px;
  border-radius: 0px;
  background: #FFFFFF;
  display: flex;
  justify-content: flex-start;
}

.second-bar-admin {
  margin-top: 28px;
  margin-bottom: 28px;
}

.quick-filter-action {
  min-height: 39px;
  border-radius: 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  padding: 13px;
  margin-right: 1px;
  cursor: pointer;
}
.list-status-history {
  margin-right: 5px;
  width: 39px;
  height: 25px;
  border-radius: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 13px;
  text-align: center;
  padding-top: 5px;
}
.course-extension-table {
  margin-top: 15px;
}
</style>
